import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../../layouts';
import { Button, InputField } from '../../components';
import { WELCOME_PAGE_ROUTE } from '../../utils/consts';

const LoginPage = () => {
	return (
		<>
			<Header has_sidebar={false} />
			<div className='container min-vh-90'>
				<div className='row min-vh-90 align-items-center justify-content-center'>
					<div className='col-12 col-md-7 col-xl-5'>
						<form className='py-5 px-3 px-sm-4 px-lg-5 background-secondary border-tertiary w-100 rounded-4'>
							<h1 className='title text-center mb-5'>Anmeldung</h1>
							<InputField
								id={'email'}
								classes={'background-tertiary'}
								type={'email'}
								label={'E-Mail'}
							/>
							<InputField
								id={'password'}
								classes={'background-tertiary'}
								type={'password'}
								label={'Passwort'}
							/>
							<div className='d-flex justify-content-center'>
								<Link to={WELCOME_PAGE_ROUTE}>
									<Button classes={'px-5 py-2 mt-4 rounded-3 background-blue'}>
										Login
									</Button>
								</Link>
							</div>
						</form>
					</div>
				</div>
			</div>
		</>
	);
};

export default LoginPage;
